<template>
  <a
    class="text-body pointer"
    @click.prevent="onClick(checkup.RecordNo)"
  >
    <div class="d-flex w-100 justify-content-between">
      <strong class="mb-1">
        {{ $t("checkupNumber") }}: {{ checkup.RecordNo }}
        ({{ checkup.deviceType }})
      </strong>
      <small class="text-nowrap">
        {{ checkup.created_at | moment("from", "now") }}
      </small>
    </div>
    <p class="mb-1">{{ $t("measuredParameters") }}:</p>
    <div>
      <span
        class="badge badge-primary mr-2"
        v-for="section in checkup.sections"
        :key="section"
      >
        {{ $t(section) }}
      </span>
    </div>
  </a>
</template>
<script>
export default {
  props: {
    checkup: {
      type: Object,
      required: true
    },
    onClick: {
      type: Function,
      default: function (id) {
        this.$router.push({ path: `/p/checkup/${id}` })
      }
    }
  }
}
</script>
<i18n>
{
  "ka": {
    "checkupNumber": "ექსპერს სკრინინგი ნომერი",
    "measureTime": "ჩატარდა",
    "measuredParameters": "გაზომილი პარამეტრები",
    "height": "სიმაღლე / წონა",
    "weight": "წონა",
    "temperature": "ტემპერატურა",
    "bloodFat": "ლიპიდები",
    "bloodPressure": "წნევა",
    "bloodSugar": "გლუკოზა",
    "chol": "ქოლესტერინი",
    "fat": "ცხიმიანობა",
    "PEEcg": "ელექტროკარდიოგრამა",
    "Ua": "შარდმჟავა",
    "blood_pressure": "წნევა",
    "bo": "სატურაცია",
    "whr": "WHR",
    "blood_sugar": "გლუკოზა",
    "ua": "შარდმჟავა",
    "hb": "ჰემოგლობინი",
    "peecg": "ელექტრო კარდიოგრამა",
    "blood_fat": "ლიპიდები",
    "arteryAve": ""
  }
}
</i18n>
